import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromLayoutSelectors from '../../../store/selectors/layout.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-inner-content',
  standalone: false,
  templateUrl: './inner-content.component.html'
})
export class InnerContentComponent {
  private store = inject(Store);

  useMobileLayout$: Observable<boolean>;

  @Input() scrollX = true;
  @Input() paddingBottom = false;

  constructor() {
    this.useMobileLayout$ = this.store.pipe(select(fromLayoutSelectors.selectUseMobileLayout));
  }
}
